module.exports = __webpack_public_path__ + "static/media/nina.d5192ce9.jpg";